import Banner from '../components/Banner';
import Footer from '../components/Footer';
import ResPassword from '../components/ResetPassword'; // <-- tu componente de pedir email
import '../styles/Login.css';

const ForgotPasswordPage: React.FC = () => {
  return (
    <div className="page-container">
      <Banner />
      <main className="login-main">
        <ResPassword />
      </main>
      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;
